import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Container, Grid, Stack, Typography } from "@mui/material";

import {
  help_links,
  info_links,
  legal_links,
  privacy_links,
  documentation_links,
} from "../../consts/Footer/links";

import LinkList from "./LinkList";
import SocialIcons from "./SocialIcons";
import FooterBottom from "./FooterBottom";
import PaymentMethods from "./PaymentMethods";
import ContactDetails from "./ContactDetails";
import SubscribeSection from "./SubscribeSection";
import ServicesDropdown from "./ServicesDropdown";
import DownloadAppSection from "./DownloadAppSection";

import { VerticalSeparator, Wrapper } from "./styles";
import CBXWhiteLogo from "../Icons/CBXWhiteLogo";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} md={7} lg={7} xl={7}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={3}>
                <Stack direction="column" gap="32px">
                  <CBXWhiteLogo width={76} height={44} />
                  <Stack gap="0.5rem">
                    <Typography color="white" variant="body2">
                      {t("footer.follow_us")}
                    </Typography>
                    <SocialIcons />
                    <ContactDetails />
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={12} md={9} sx={{ pt: [6, 6, 0] }}>
                <Grid container sx={{ pt: [6, 6, 0] }}>
                  <Grid item xs={6}>
                    <Stack direction="row">
                      <VerticalSeparator />
                      <Stack direction="column" gap="16px">
                        <ServicesDropdown />
                        <LinkList
                          title="footer.documentation"
                          links={documentation_links}
                        />
                        <LinkList title="footer.help" links={help_links} />
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack>
                      <Stack direction="column" gap="16px">
                        <LinkList
                          title="footer.additional_information"
                          links={info_links}
                        />
                        <LinkList
                          title="footer.privacy"
                          links={privacy_links}
                        />
                        <LinkList title="footer.legal" links={legal_links} />
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={5} lg={5} xl={5}>
            <Stack direction="row" width="100%">
              <VerticalSeparator />
              <Stack gap="16px" width="100%">
                <SubscribeSection />
                <Stack gap="16px">
                  <DownloadAppSection />
                  <PaymentMethods />
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
        <FooterBottom />
      </Container>
    </Wrapper>
  );
}
